import { CUSTOM_CLASS_NAME } from 'core/constants'
import { layoutSmall } from 'core/util/default'
import React from 'react'
import styled, { css } from 'styled-components'

interface SkeletonScheduleImageProps {}

const SkeletonScheduleImage: React.FC<SkeletonScheduleImageProps> = (props) => {
  return (
    <StyledSkeletonScheduleImage className={CUSTOM_CLASS_NAME.SCHEDULE_CARD_SKELETON}>
      <div className="skeleton schedule_wrapper" />
    </StyledSkeletonScheduleImage>
  )
}

const StyledSkeletonScheduleImage = styled.div`
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }
  .skeleton {
    background-color: ${(props) => props.theme.skeleton};
    background-image: ${(props) => props.theme.skeletonGradation};
    background-size: 40px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
  }
  .schedule_wrapper {
    width: 384px;
    height: 288px;
    border-radius: 4px;
    overflow: hidden;
  }
  ${layoutSmall(css`
    .schedule_wrapper {
      width: 323px;
      height: 243px;
    }
  `)}
`
export default SkeletonScheduleImage
